import { Component, ChangeDetectionStrategy } from "@angular/core";
import { ToasterService } from "@shared/services/toaster.service";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FormsModule } from "@angular/forms";

export interface AdminTermsNewEditPublishDialogContext {
}

@Component({
    templateUrl: "./publish.component.html",
    styleUrls: ["./publish.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, TranslatePipe]
})
export class AdminTermsNewEditPublishDialogComponent {

    public version: string;

    constructor(
        public modal: NgbActiveModal, private readonly toaster: ToasterService, public translate: TranslateService,
    ) {
    }

    public publish() {
        if (!this.version?.trim()) {
            this.translate.get('Please enter a version number').subscribe((res: string) => {
                this.toaster.pop("warning", res);
            });
            return;
        }
        this.modal.close(this.version);
    }
}
